import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Google Logo",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_26",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 4,
			y: 4,
			width: 32,
			height: 32,
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M35.3644 17.0316H20.3337V23.1831H28.9704C28.8316 24.0537 28.5198 24.9101 28.0633 25.691C27.5402 26.5858 26.8936 27.2669 26.2308 27.7857C24.2454 29.3395 21.9308 29.6572 20.3232 29.6572C16.2624 29.6572 12.7928 26.9766 11.4496 23.3341C11.3954 23.2019 11.3594 23.0654 11.3155 22.9304C11.0187 22.0034 10.8566 21.0215 10.8566 20.001C10.8566 18.939 11.0322 17.9223 11.3524 16.9621C12.6154 13.1752 16.1633 10.3467 20.3262 10.3467C21.1635 10.3467 21.9698 10.4485 22.7344 10.6516C24.4819 11.1156 25.718 12.0295 26.4754 12.7524L31.0457 8.18101C28.2656 5.57756 24.6416 4 20.3186 4C16.8626 3.99993 13.6719 5.09971 11.0573 6.95838C8.93687 8.46571 7.19784 10.4838 6.0242 12.8277C4.93255 15.0009 4.3348 17.4092 4.3348 19.9986C4.3348 22.5881 4.93346 25.0215 6.02512 27.1746V27.1891C7.17817 29.4749 8.86433 31.4431 10.9137 32.9435C12.704 34.2543 15.9142 36 20.3186 36C22.8514 36 25.0961 35.5336 27.0758 34.6595C28.504 34.029 29.7693 33.2066 30.9149 32.1496C32.4286 30.753 33.6141 29.0255 34.4233 27.038C35.2324 25.0505 35.6653 22.8029 35.6653 20.3662C35.6653 19.2314 35.5537 18.0789 35.3644 17.0315V17.0316Z",
				fill: "black"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_0_26)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_2",
					filter: "url(#filter0_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M4.10426 20.1073C4.12088 22.6559 4.83191 25.2855 5.90819 27.4083V27.4229C6.68584 28.9645 7.74868 30.1823 8.95923 31.3888L16.2706 28.6641C14.8874 27.9464 14.6763 27.5066 13.6847 26.7042C12.6714 25.6606 11.9162 24.4625 11.4458 23.0577H11.4269L11.4458 23.0431C11.1364 22.1154 11.1059 21.1307 11.0945 20.1073H4.10426Z",
						fill: "url(#paint0_radial_0_26)"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_3",
					filter: "url(#filter1_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M20.3339 3.88362C19.6112 6.47668 19.8875 8.99721 20.3339 10.4638C21.1684 10.4644 21.9723 10.566 22.7345 10.7684C24.482 11.2324 25.718 12.1463 26.4754 12.8692L31.1626 8.18108C28.3859 5.58073 25.0443 3.88772 20.3339 3.88362Z",
						fill: "url(#paint1_radial_0_26)"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_4",
					filter: "url(#filter2_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M20.3182 3.86312C16.7735 3.86304 13.5009 4.99106 10.8191 6.89745C9.82339 7.6053 8.90962 8.42297 8.09596 9.33225C7.8828 11.3747 9.69162 13.8851 13.2736 13.8644C15.0116 11.7995 17.582 10.4635 20.4429 10.4635C20.4455 10.4635 20.4481 10.4638 20.4507 10.4638L20.3338 3.86358C20.3286 3.86358 20.3235 3.86312 20.3182 3.86312Z",
						fill: "url(#paint2_radial_0_26)"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_5",
					filter: "url(#filter3_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M32.0176 20.8464L28.8537 23.0663C28.7149 23.9369 28.4029 24.7933 27.9464 25.5743C27.4233 26.469 26.7767 27.1502 26.1139 27.6689C24.1327 29.2196 21.8241 29.5388 20.217 29.5401C18.5559 32.4297 18.2647 33.8771 20.3338 36.2093C22.8942 36.2073 25.1641 35.7353 27.1662 34.8513C28.6135 34.2123 29.8958 33.3788 31.0567 32.3077C32.5907 30.8923 33.7923 29.1416 34.6124 27.1274C35.4324 25.1133 35.8709 22.8357 35.8709 20.3663L32.0176 20.8464Z",
						fill: "url(#paint3_radial_0_26)"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_6",
					filter: "url(#filter4_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M20.1002 16.7979V23.4169H35.3223C35.4561 22.5104 35.8989 21.3374 35.8989 20.3663C35.8989 19.2315 35.7874 17.8454 35.5981 16.7979H20.1002Z",
						fill: "#3086FF"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_7",
					filter: "url(#filter5_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M8.16858 9.09858C7.22921 10.1483 6.42671 11.3233 5.79042 12.594C4.69879 14.7672 4.10107 17.4092 4.10107 19.9986C4.10107 20.0351 4.10403 20.0708 4.10427 20.1073C4.58772 21.054 10.7823 20.8727 11.0945 20.1073C11.0941 20.0716 11.0902 20.0367 11.0902 20.0009C11.0902 18.9389 11.2658 18.1561 11.586 17.1959C11.9811 16.0115 12.5996 14.9209 13.3905 13.9812C13.5698 13.7474 14.048 13.2448 14.1875 12.9434C14.2407 12.8285 14.091 12.7641 14.0827 12.7237C14.0733 12.6785 13.8727 12.7148 13.8277 12.6811C13.685 12.5742 13.4024 12.5184 13.2308 12.4688C12.864 12.3627 12.2561 12.1288 11.9185 11.8863C10.8512 11.1198 9.18569 10.2042 8.16858 9.09858Z",
						fill: "url(#paint4_radial_0_26)"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_8",
					filter: "url(#filter6_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M11.9414 12.7282C14.4163 14.2594 15.128 11.9553 16.7734 11.2343L13.9111 5.17186C12.8582 5.62385 11.8634 6.18541 10.9404 6.84154C9.562 7.82143 8.34474 9.01717 7.3392 10.3779L11.9414 12.7282Z",
						fill: "url(#paint5_radial_0_26)"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_9",
					filter: "url(#filter7_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M12.9487 28.1957C9.62651 29.4207 9.10641 29.4646 8.80061 31.5675C9.38499 32.1499 10.0129 32.6887 10.6801 33.1772C12.4704 34.488 15.9142 36.2337 20.3185 36.2337C20.3237 36.2337 20.3287 36.2332 20.3338 36.2332V29.4233C20.3305 29.4233 20.3267 29.4235 20.3233 29.4235C18.6741 29.4235 17.3561 28.9811 16.0048 28.2117C15.6717 28.022 15.0672 28.5314 14.76 28.3037C14.3362 27.9896 13.3163 28.5743 12.9487 28.1957Z",
						fill: "url(#paint6_radial_0_26)"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Vector_10",
					opacity: .5,
					filter: "url(#filter8_f_0_26)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M18.3882 29.2088V36.1153C19.0045 36.189 19.6458 36.2337 20.3186 36.2337C20.993 36.2337 21.6455 36.1983 22.2795 36.1333V29.2554C21.569 29.3794 20.8998 29.4235 20.3233 29.4235C19.6594 29.4235 19.0138 29.3446 18.3882 29.2088Z",
						fill: "url(#paint7_linear_0_26)"
					})
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_0_26",
			x: 4.04934,
			y: 20.0524,
			width: 12.2762,
			height: 11.3914,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_f_0_26",
			x: 19.8346,
			y: 3.8287,
			width: 11.383,
			height: 9.09546,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_f_0_26",
			x: 8.02414,
			y: 3.80819,
			width: 12.4815,
			height: 10.1112,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter3_f_0_26",
			x: 18.8209,
			y: 20.3114,
			width: 17.1049,
			height: 15.9528,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter4_f_0_26",
			x: 20.0452,
			y: 16.743,
			width: 15.9086,
			height: 6.72877,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter5_f_0_26",
			x: 4.04615,
			y: 9.04365,
			width: 10.2077,
			height: 11.7624,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter6_f_0_26",
			x: 6.95307,
			y: 4.78572,
			width: 10.2065,
			height: 8.84322,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .193067,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter7_f_0_26",
			x: 8.74568,
			y: 28.1135,
			width: 11.6431,
			height: 8.17513,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter8_f_0_26",
			x: 18.3333,
			y: 29.1539,
			width: 4.00111,
			height: 7.13475,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .0274616,
					result: "effect1_foregroundBlur_0_26"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_0_26",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(16.1243 31.1488) rotate(-92.3395) scale(15.9492 23.4274)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .141612,
					stopColor: "#1ABD4D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .247515,
					stopColor: "#6EC30D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .311547,
					stopColor: "#8AC502"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .366013,
					stopColor: "#A2C600"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .445673,
					stopColor: "#C8C903"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .540305,
					stopColor: "#EBCB03"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .615636,
					stopColor: "#F7CD07"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .699345,
					stopColor: "#FDCD04"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .771242,
					stopColor: "#FDCE05"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .860566,
					stopColor: "#FFCE0A"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_0_26",
			cx: 0,
			cy: 0,
			r: 1,
			gradientTransform: "matrix(11.0566 -2.71409e-05 -1.55405e-05 14.279 30.7241 12.53)",
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .408458,
				stopColor: "#FB4E5A"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF4540"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint2_radial_0_26",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(24.686 1.79618) rotate(151.02) scale(17.7084 24.0302)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .231273,
					stopColor: "#FF4541"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .311547,
					stopColor: "#FF4540"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .457516,
					stopColor: "#FF4640"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .540305,
					stopColor: "#FF473F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .699346,
					stopColor: "#FF5138"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .771242,
					stopColor: "#FF5B33"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .860566,
					stopColor: "#FF6C29"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF8C18"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint3_radial_0_26",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(20.5641 34.1382) rotate(-127.454) scale(46.1969 17.0524)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .131546,
					stopColor: "#0CBA65"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .209784,
					stopColor: "#0BB86D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .297297,
					stopColor: "#09B479"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .396257,
					stopColor: "#08AD93"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .477124,
					stopColor: "#0AA6A9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .568425,
					stopColor: "#0D9CC6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .667385,
					stopColor: "#1893DD"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .768727,
					stopColor: "#258BF1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .858506,
					stopColor: "#3086FF"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint4_radial_0_26",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(18.961 6.88542) rotate(96.6178) scale(17.2512 23.8527)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .366013,
					stopColor: "#FF4E3A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .457516,
					stopColor: "#FF8A1B"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .540305,
					stopColor: "#FFA312"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .615636,
					stopColor: "#FFB60C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .771242,
					stopColor: "#FFCD0A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .860566,
					stopColor: "#FECF0A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .915033,
					stopColor: "#FECF08"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FDCD01"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint5_radial_0_26",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(16.1652 6.70766) rotate(132.119) scale(8.56851 24.1679)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .315904,
					stopColor: "#FF4C3C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .603818,
					stopColor: "#FF692C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .726837,
					stopColor: "#FF7825"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .884534,
					stopColor: "#FF8D1B"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF9F13"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint6_radial_0_26",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(24.686 38.2034) rotate(-151.02) scale(17.7084 24.0302)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .231273,
					stopColor: "#0FBC5F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .311547,
					stopColor: "#0FBC5F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .366013,
					stopColor: "#0FBC5E"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .457516,
					stopColor: "#0FBC5D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .540305,
					stopColor: "#12BC58"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .699346,
					stopColor: "#28BF3C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .771242,
					stopColor: "#38C02B"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .860566,
					stopColor: "#52C218"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .915033,
					stopColor: "#67C30F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#86C504"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint7_linear_0_26",
			x1: 18.3882,
			y1: 32.7213,
			x2: 22.2795,
			y2: 32.7213,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0FBC5C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0CBA65"
			})]
		})
	] })]
});
export default SvgGoogle;
